import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Layout } from 'antd'
import '../../styleLess/signature/overviewAll.scss'
import { getCookie } from 'helper/cookie'
import { RightOutlined } from '@ant-design/icons'
import { useParams } from 'react-router-dom'
import { useHistory } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import 'styleLess/signature/shimmerloading.scss'
import Iframe from './components/Iframe.components'
import { REACT_APP_URL } from '../../config/env'

const Container = styled.div`
  // width: 100%;
  // background: #ffffff;
  // padding: 24px;
`
const TextTitleBold = styled.h2`
  font-family: 'IBMPlexSansThaiBold';
  line-height: 2;
`

const QuickUpdateMain = (props) => {
  const token = getCookie('access_token_admin')
  const history = useHistory()
  const { id } = useParams()


  useEffect(() => {
    if (token) {
      window.scrollTo(0, 0)
    }
  }, [token])
  const goProjectList = () => {
    history.push('/project-list')
  }

  return (
    <Container className='main-container'>
      <Helmet>
        <title>AXONS PROJECT | Overview</title>
      </Helmet>
      <div className='BreadCrumb '>
        <h4 className='level1' onClick={() => goProjectList()}>
          Project
        </h4>
        <RightOutlined className='icon-style' style={{ marginTop: -6 }} />
        <h4
          className='level2 cutter-text-line-1 '
          style={{ minHeight: 28, maxWidth: '60%' }}
        >
          Project Update
        </h4>
      </div>
      <h1
        className='cutter-text-line-1 responset'
        style={{
          minHeight: 43,
          maxWidth: '64%',
          fontFamily: 'IBMPlexSansThaiBold',
          lineHeight: 2,
        }}
      >
        Project Update
      </h1>
      <Layout className='layout-overview'>
        <Iframe
          source={`${REACT_APP_URL}/v2/project-quickupdate/${id}`}
        />
      </Layout>



    </Container>
  )
}

export default QuickUpdateMain
